import React, {Component} from 'react';
import PropTypes from "prop-types";
import Caret from "../../../assets/img/caret_down_white.svg";

export default class BankSavingDropdown extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    class: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      class: this.props.class,
      showOverlay: false
    };
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown() {
    this.setState({
      showOverlay: !this.state.showOverlay
    })
  }

  handleOutsideClick = (ev) => {
    if (this.state.showOverlay && !this.node.contains(ev.target)) {
      this.toggleDropdown();
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  render() {
    return (
      <li className={this.state.class + (this.state.showOverlay ? ' show' : '')} onClick={this.toggleDropdown} ref={node => this.node = node}>
        <div className={'budget-header-overlay'}/>
        <div className={'inner-dropdown'}>
          {this.state.title}:
          <div className={'dropdown inner-dropdown'}>
            <span>
              <p title={this.props.globas}>{this.props.globas}</p>
              <div className={'dropdown-arrow'}>
                <img alt={'caret'} src={Caret}/>
              </div>
            </span>
          </div>
        </div>
        <div className={'dropdown-content'} onClick={(ev) => {ev.stopPropagation()}}>
          {this.props.onlyThumbTitle ? null : <h3>{this.state.title}</h3>}
          {this.props.children}
        </div>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/StepThree/BankSavingDropdown.js